<template>
  <div class="processing-time">
    <div class="header">
      <h1>IRCC各类移民签证申请审批时间表</h1>
      <p class="update-time">最新更新时间: {{ updateTime }}</p>
    </div>

    <div class="table-section">
      <h2>永久居民类别</h2>
      <table>
        <thead>
          <tr>
            <th>签证类别</th>
            <th>最长处理时间</th>
            <th>申请周期</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in permanentResidentData" :key="index">
            <td>{{ item.category }}</td>
            <td>{{ item.maxTime }}</td>
            <td>{{ item.processingTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-section">
      <h2>临时居民签证</h2>
      <table>
        <thead>
          <tr>
            <th>签证类别</th>
            <th>最长处理时间</th>
            <th>申请周期</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in temporaryResidentData" :key="index">
            <td>{{ item.category }}</td>
            <td>{{ item.maxTime }}</td>
            <td>{{ item.processingTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcessingTimeView',
  data() {
    return {
      updateTime: '2024年4月1日',
      permanentResidentData: [
        { category: '技术移民FSW', maxTime: '6个月', processingTime: '-' },
        { category: '加拿大经验类移民CEC', maxTime: '5个月', processingTime: '-' },
        { category: '大西洋移民项目AIP', maxTime: '11个月', processingTime: '-' },
        { category: '省提名（EE）', maxTime: '6个月', processingTime: '-' },
        { category: '创业移民SUV', maxTime: '40个月', processingTime: '-' },
        { category: '自雇Self-Employed Persons', maxTime: '50个月', processingTime: '-' },
        { category: '担保配偶（魁北克以外）', maxTime: '24个月', processingTime: '11个月' },
        { category: '担保子女（魁北克以外）', maxTime: '16个月', processingTime: '8个月' },
        { category: '担保父母祖父母（魁北克以外）', maxTime: '36个月', processingTime: '36个月' },
        { category: '申请回补', maxTime: '14天', processingTime: '-' },
        { category: '新叶卡续期', maxTime: '11天', processingTime: '-' },
        { category: '入籍', maxTime: '8个月', processingTime: '-' }
      ],
      temporaryResidentData: [
        { category: '旅游探亲签证Visitor Visa', maxTime: '14天', processingTime: '27天' },
        { category: '旅游探亲签证延签Visitor Extension (Visitor Record)', maxTime: '180天', processingTime: '-' },
        { category: '超级签证Super Visa', maxTime: '-', processingTime: '117天' },
        { category: '学签Study Permit', maxTime: '3周', processingTime: '4周' },
        { category: '学签延签Study Permit Extension', maxTime: '120天', processingTime: '-' },
        { category: '工签Work Permit', maxTime: '121天（包含各种类型）', processingTime: '13周' },
        { category: '毕业工签PGWP', maxTime: '121天', processingTime: '13周' },
        { category: '配偶工签BOWP', maxTime: '121天', processingTime: '-' }
      ]
    }
  }
}
</script>

<style scoped>
.processing-time {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.header {
  text-align: center;
  margin-bottom: 40px;
}

.header h1 {
  color: #333;
  margin-bottom: 10px;
}

.update-time {
  color: #666;
  font-size: 14px;
}

.table-section {
  margin-bottom: 40px;
}

.table-section h2 {
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e60012;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

th, td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

th {
  background-color: #e60012;
  color: #fff;
  font-weight: 500;
}

tr:hover {
  background-color: #f5f5f5;
}

@media (max-width: 768px) {
  .processing-time {
    padding: 20px 10px;
  }

  table {
    font-size: 14px;
  }

  th, td {
    padding: 10px;
  }
}
</style>